import script from "./App.vue?vue&type=script&lang=ts&setup=true"
export * from "./App.vue?vue&type=script&lang=ts&setup=true"

import "./App.vue?vue&type=style&index=0&id=2e1a5132&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e1a5132"]])

export default __exports__